<template>
    <input
        type="checkbox"
        v-model="checked"
    />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
    },

    emits: {
        "update:modelValue": (payload: number) => typeof payload === "number",
    },

    setup(props, {emit})
    {
        const checked = ref<boolean>(!!props.modelValue);

        watch(checked, (newValue) => {
            emit("update:modelValue", newValue ? 1 : 0);
        });

        return { checked };
    },
})
</script>
